import { useMutation } from "@tanstack/react-query";
import { sendSMS } from "./messagesApi";

export function useSendSMS() {
  return useMutation({
    mutationFn: ({ message, to }: { message: string; to: string }) =>
      sendSMS(message, to),
  });
}
